/** @jsxImportSource @emotion/react */
import SwitcherStyle from './IDSSwitcherStyle'
import IDSFilterDropDown from './IDSFilterDropDown'
import useTenantsQuery from './hooks/useTenantsQuery'

const IDSSwitcherFilter = ({
  setShowDropdownFilter,
  showDropdownFilter,
  refContainer,
  tenantsIncluded,
}) => {
  const {
    dropdownFilterHandler,
    handleInputChange,
    handleKeyChange,
    tenants,
    query,
  } = useTenantsQuery(setShowDropdownFilter, tenantsIncluded)

  const parseUrl = window.location.host.split('.')
  const tenant = parseUrl[0].replace(/-/g, '_')

  const tenantsForDisplay = tenants.filter(
    item => item.attributes.identifier !== tenant
  )

  return (
    <div css={SwitcherStyle.dropDown}>
      <button
        onClick={dropdownFilterHandler}
        css={SwitcherStyle.dropDown.dropBtn}
      >
        <span> Search </span>
        <b
          css={
            showDropdownFilter
              ? SwitcherStyle.dropDown.selectedArrow
              : SwitcherStyle.dropDown.arrow
          }
        ></b>
      </button>
      {showDropdownFilter && (
        <IDSFilterDropDown
          refContainer={refContainer}
          tenants={tenantsForDisplay}
          handleInputChange={handleInputChange}
          handleKeyChange={handleKeyChange}
          query={query}
        />
      )}
    </div>
  )
}

export default IDSSwitcherFilter
